/**
 * Constants shared between the marketing copy pipeline and client-side
 * pricing code. Kept separate from marketingCopy.ts so client bundles
 * that only need a fallback value never pull in the Sanity client.
 */

/**
 * Fallback for the Sanity promoDiscountPercent field. Must be kept in
 * step with the Stripe default checkout coupon (DEFAULT_CHECKOUT_COUPON,
 * currently preseason2026 at 50%) - see FFH-1746.
 */
export const DEFAULT_PROMO_DISCOUNT_PERCENT = 50;

/**
 * Resolves the discount percent actually applied to displayed prices from
 * the two Sanity fields: the promoPricingEnabled toggle and the
 * promoDiscountPercent value. Downstream code only ever sees the resolved
 * number — 0 means "no promo" and suppresses the strike-through price.
 *
 * A missing toggle (the field not yet published on the live document)
 * resolves to enabled, so deploying this code ahead of the Sanity publish
 * changes nothing.
 */
export const resolveEffectiveDiscountPercent = (
  promoDiscountPercent: number | null | undefined,
  promoPricingEnabled: boolean | null | undefined
): number =>
  (promoPricingEnabled ?? true)
    ? promoDiscountPercent ?? DEFAULT_PROMO_DISCOUNT_PERCENT
    : 0;
